<template>
  <div>
    <PageAllow controller="Roles" action="index" />
    <Breadcrumbs :items="items" />

    <v-slide-x-transition>
      <v-sheet
        v-show="!currentItemMode"
        class="transparent-background-color fill-content-height"
      >
        <v-row dense class="mx-5">
          <v-col cols="12" sm="8" md="4">
            <v-row dense align="center" class="pa-1">
              <SearcherKeyword
                ref="name"
                v-model="options.keyword"
                @text="keyword = $event"
                :label="$t('Role.keyword')"
              />
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="8" align-self="center">
            <v-row dense align="center" class="search-controls">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                      v-bind="attrs"
                      v-on="on"
                      small
                      text
                      class="px-0 py-0 caption font-weight-bold grey--text"
                      color="primary"
                      @click.stop="onSearch()"
                  >
                    <v-icon small class="pe-1">fa-search</v-icon>
                    {{ $t("Search.search") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.searchTip") }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                      v-bind="attrs"
                      v-on="on"
                      small
                      text
                      class="caption font-weight-bold grey--text"
                      @click.stop="resetSearch()"
                  >
                    <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                    {{ $t("Search.reset") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.resetTip") }}</span>
              </v-tooltip>
              <v-spacer />
              <v-btn
                small
                color="primary"
                @click.stop="
                  currentItemMode = 'new';
                  currentItem = { id: 0 };
                "
                class="ms-1"
              >
                <v-icon x-small class="pe-1">fa-plus</v-icon>
                {{ $t("CRUD.newInfo", [$t("Role.ObjectName")]) }}
              </v-btn>
            </v-row>
          </v-col>
        </v-row>

        <!-- 表格 -->
        <div class="mx-4 my-4">
          <v-data-table
            :headers="headers"
            :items="roles"
            :options.sync="options"
            :loading="loading"
            :page.sync="paging.page"
            :server-items-length="paging.count"
            multi-sort
            class="elevation-1 px-4 pt-1"
            :footer-props="$t('$config.footer-props')"
          >
            <template v-slot:header.actions="{ header }">
              {{ header.text }}
              <v-icon x-small>fa-sliders-h</v-icon>
            </template>
            <template v-slot:item.account_user_count="{ item }">
              <a
                style="text-decoration: none"
                @click.stop="routerAccountUser(item)"
              >
                {{ item.account_user_count }}
              </a>

            </template>
            <template v-slot:item.actions="{ item }">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    small
                    v-bind="attrs"
                    v-on="on"
                    color="primary"
                    class="px-1 py-4 me-1"
                    @click.stop="
                      currentItemMode = 'edit';
                      currentItem = item;
                    "
                    >fa-pencil-alt
                  </v-icon>
                </template>
                <span>
                  {{ $t("CRUD.editInfo", [$t("Role.ObjectName")]) }}
                </span>
              </v-tooltip>
              <v-tooltip top v-if="item.deletable">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    small
                    v-bind="attrs"
                    v-on="on"
                    color="danger"
                    class="px-1 me-1"
                    @click.stop="
                      currentItem = item;
                      deleteDialog = true;
                    "
                    >fa-trash-alt
                  </v-icon>
                </template>
                <span>
                  {{ $t("CRUD.deleteInfo", [$t("Role.ObjectName")]) }}
                </span>
              </v-tooltip>
            </template>
          </v-data-table>
        </div>
      </v-sheet>
    </v-slide-x-transition>

    <RoleDetail
      v-show="currentItemMode"
      v-model="currentItem"
      :mode="currentItemMode"
      @mode="currentItemMode = $event"
      @save="getRolesFromAPI()"
    />
    <DialogDelete
      v-model="deleteDialog"
      :label="$t('Role.ObjectName')"
      @confirm="
        deleteRole();
        deleteDialog = false;
      "
    />
  </div>
</template>
<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import RoleDetail from "./plugins/Detail";
import DialogDelete from "@/components/plugins/DialogDelete";
import Roles from "@/api/roles";
import SearcherKeyword from "@/components/plugins/SearcherKeyword.vue";

const defaultOptions = {
  keyword: null
};

export default {
  components: {
    SearcherKeyword,
    PageAllow,
    Breadcrumbs,
    RoleDetail,
    DialogDelete,
  },

  computed: {
    items: () => [
      {
        text: i18n.t("SettingNav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("SettingNav.settings"),
        disabled: false,
        href: "/settings/bussiness-settings",
      },
      {
        text: i18n.t("SettingNav.roles"),
        disabled: true,
        href: "/settings/roles",
      },
    ],

    headers: () => [
      {
        text: i18n.t("Role.RolePermissionFields.name"),
        align: "start",
        sortable: false,
        value: "role_name",
      },
      {
        text: i18n.t("Role.RolePermissionFields.description"),
        align: "center",
        sortable: false,
        value: "description",
      },
      {
        text: i18n.t("Role.RolePermissionFields.account_user_count"),
        align: "center",
        sortable: false,
        value: "account_user_count",
      },
      {
        text: i18n.t("TableHeaders.actions"),
        align: "start",
        sortable: false,
        value: "actions",
      },
    ],

    ...mapState(["loading", "settings"]),
  },

  data: () => ({
    options: JSON.parse(JSON.stringify(defaultOptions)),
    keyword: "",
    paging: {},
    roles: [],
    deleteDialog: false,
    currentItem: null,
    currentItemMode: null,
  }),

  mounted() {
    this.getRolesFromAPI();
  },

  methods: {
    resetSearch() {
      this.options = JSON.parse(JSON.stringify(defaultOptions));
    },
    onSearch() {
      this.options = Object.assign({}, this.options, {
        keyword: this.keyword,
      });
    },
    getRolesFromAPI() {
      Roles.fetch(this.options).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.roles = response.data.roles;
            this.paging = response.data.paging;
          } else if (response.data.error.code.isNoResultSet()) {
            this.options.page = 1;
          }
        }.bind(this)
      );
    },
    deleteRole() {
      if (this.currentItem)
        Roles.del(this.currentItem.id).then(
          function (response) {
            if (response.data.status.isOK()) {
              this.getRolesFromAPI(); // 删除成功的话刷新数据
            }
          }.bind(this)
        );
    },
    routerAccountUser(item) {
      sessionStorage.setItem(
          'account_user-rolesSelected',
          JSON.stringify([item])
      );
      this.$router.push('/settings/account-users');
    },
  },

  watch: {
    $route() {
      if (!this.$route.query.id) {
        this.currentItemMode = null;
        this.currentItem = null;
      }
    },
    currentItem: {
      handler() {
        if (this.currentItem) {
          this.$router.replace("/settings/roles?id=" + this.currentItem.id);
          this.$cacheScrollLocation();
        } else {
          this.$scrollToCachedLocation();
          this.$router.replace("/settings/roles");
        }
      },
    },

    options: {
      deep: true,
      handler() {
        this.getRolesFromAPI();
      },
    },
  },
};
</script>